import YouTube from 'react-youtube';

import React from 'react'
import { Box } from '@mui/material';

export default function YoutubeContainer({ videoId }) {
    return (
        <Box sx={{ height: 1, width: 1, position: 'relative' }}>
            <Box sx={{ position: 'absolute', top: 0, left: 0, width: 1, height: 1 }}></Box>
            <Box
                component={YouTube}
                opts={{
                    height: '100%',
                    width: '100%',
                    playerVars: {
                        playlist: videoId ?? 'https://www.youtube.com/embed/TAj2K1jYec8?playlist=TAj2K1jYec8&loop=1&autoplay=1&controls=0&mute=1&enablejsapi=1&disablekb=1&origin=https%3A%2F%2Fhyper-active.com&widgetid=1',
                        loop: 1,
                        autoplay: 1,
                        controls: 0,
                        mute: 1,
                        enablejsapi: 1,
                        disablekb: 1,
                        origin: 'https://hyper-active.com/'
                    },
                }}
                sx={{
                    width: 1,
                    height: 1,
                    borderRadius: '20px',
                    overflow: 'hidden'
                }}
                videoId={videoId ?? 'https://www.youtube.com/embed/TAj2K1jYec8?playlist=TAj2K1jYec8&loop=1&autoplay=1&controls=0&mute=1&enablejsapi=1&disablekb=1&origin=https%3A%2F%2Fhyper-active.com&widgetid=1'}
                title={'Youtube Video Player'}
            />
        </Box>
    )
}